<template>
  <v-list-item data-testid="view-as-member-toggle" @click="requestToggle">
    <template #prepend>
      <v-icon :icon="isViewAsMemberEnabled ? mdiAccountSwitchOutline : mdiAccountSwitch" />
    </template>
    <v-list-item-title>
      {{ isViewAsMemberEnabled ? "Exit member view" : "View as Member" }}
    </v-list-item-title>
    <v-list-item-subtitle v-if="!isViewAsMemberEnabled"> See the site as a regular member would </v-list-item-subtitle>
    <template #append>
      <v-switch
        :model-value="isViewAsMemberEnabled"
        density="compact"
        hide-details
        color="primary"
        inset
        @click.stop.prevent="requestToggle"
      />
    </template>
  </v-list-item>
</template>

<script setup lang="ts">
import { mdiAccountSwitch, mdiAccountSwitchOutline } from "@mdi/js";
import { useViewAsMember } from "@/composables/useViewAsMember";

const { isViewAsMemberEnabled, setViewAsMember } = useViewAsMember();

// Enabling member view is gated behind a confirmation to prevent an accidental
// one-tap enable; the confirm dialog lives in the app shell (MainLayout) so it
// survives this menu closing on click. Exiting is immediate (no confirmation)
// so an officer who finds themselves stuck can always get out in one click.
const emit = defineEmits<{ requestEnable: [] }>();

function requestToggle() {
  if (isViewAsMemberEnabled.value) {
    setViewAsMember(false);
  } else {
    emit("requestEnable");
  }
}
</script>
